<script>
  import { onDestroy } from 'svelte';

  import Log from '@utils/log';
  import Notification from '@utils/notification';
  import BookmarkAjax from '@ajax/bookmark';
  import BookmarkCollectionAjax from '@ajax/bookmark_collection';

  import Modal from '@components/Modal.svelte';
  import CreateAccountModal from '@app-components/modal/CreateAccountModal.svelte';
  import AfterCreateInfo from '@app-components/modal/create_account/AfterCreateInfo.svelte';
  import MoveToBookmarkCollectionModal from '@app-components/modal/MoveToBookmarkCollectionModal.svelte';

  import { getGlobalStore } from '@stores/global';
  import { getCurrentUserStore } from '@stores/current_user';
  import { createEventDispatcher } from 'svelte';
  const dispatch = createEventDispatcher();

  let bookmarkStore = getGlobalStore('bookmarkStore');
  let bookmarkCollectionStore = getGlobalStore('bookmarkCollectionStore');
  let bookmarkCollectionSelectedStore = getGlobalStore('bookmarkCollectionSelectedStore');

  export let group;
  export let rec;
  export let viewStyle = '';
  export let mobile = false;
  export let bookmark;
  export let mobileForCreate = false;

  let bookmarks = bookmarkStore;
  let currentUser = getCurrentUserStore('default');

  let showCreateAccountModal = false;
  let showInfoStepsModal = false;
  let saving = false;
  let activeBookmark = null;
  let showMoveToBookmarkCollectionModal = false;
  let hideMoveToBookmarkCollectionModal = function () {
    showMoveToBookmarkCollectionModal = false;
  };

  let unsub = bookmarks.subscribe((x) => {
    bookmarks = x;

    if (!bookmark && currentUser && currentUser.id) {
      if (group) {
        bookmark = bookmarks.one({ group_base_id: group.id, user_id: currentUser.id });
      } else if (rec) {
        bookmark = bookmarks.one({ rec_id: rec.id, user_id: currentUser.id });
      }
    } else if (bookmark) {
      bookmark = bookmarks.find(bookmark.id);
    }
  });

  let bindWindowEvents = function () {
    window.manageBookmarks = async function () {
      bookmarkCollectionStore.set(await BookmarkCollectionAjax.get());
      showMoveToBookmarkCollectionModal = true;
    };
  };
  export let toggleBookmark = async function () {
    if (saving) {
      return;
    }

    if (!currentUser || !currentUser.id) {
      displayCreateAccountModal();
      return;
    }

    let data = {};

    if (group) {
      data['group_base_id'] = group.id;
    }

    if (rec) {
      data['rec_id'] = rec.id;
    }

    saving = true;

    let viewButton = `<span style="margin-right: 10px" class="bookmark-button-view-button"><a href="${
      currentUser && currentUser.profile_path
    }/bookmarks" style="color: #A893F9;">View</a></span>`;
    let manageButton = `<span style="color: #A893F9; font-size: 12px; line-height: 12px;" class="bookmark-button-view-button" onclick='manageBookmarks()'>Manage <img width='12' height='12' src="/images/Arrow.svg" style="margin-right: 10px;"></span>`;
    let showManageBookmarks = false;

    if (bookmark && bookmark.id) {
      bookmarks.remove(bookmark);
      BookmarkAjax.delete(data);
      bookmark = undefined;

      Notification.send({
        text: `<div style="display: flex; align-items: center;"><span style="background: #2CAF87; border-radius: 999px; width: 20px; height: 20px; display: inline-flex; align-items: center; justify-content: center; margin-right: 10px;"><i class="fa fa-check" style="color: white; padding-left: 2px; padding-top: -1px;"></i></span><span style="flex: 1">Removed from bookmarks</span>${viewButton}</div>`,
      });
    } else {
      let collectionId = null;
      if (bookmarkCollectionSelectedStore && bookmarkCollectionSelectedStore.collection) {
        collectionId = bookmarkCollectionSelectedStore.collection;
        data['bookmark_collection_id'] = collectionId;
      } else if (bookmarkCollectionSelectedStore && !bookmarkCollectionSelectedStore.manageBookmarksShown) {
        bookmarkCollectionSelectedStore.set({ manageBookmarksShown: true });
        showManageBookmarks = true;
      }
      activeBookmark = await BookmarkAjax.create(data);
      bookmarks.add(activeBookmark);
      setTimeout(() => bindWindowEvents(), 0);

      let notificationText = 'Saved to bookmarks';
      if (collectionId && collectionId.length > 0) {
        const collection = bookmarkCollectionStore.find(collectionId[0]);
        if (collection) {
          if (collectionId.length > 1) {
            notificationText = `Bookmark added to ${collection.name} and ${collectionId.length - 1} more`;
          } else {
            notificationText = `Bookmark added to ${collection.name}`;
          }
        }
      }
      if (!showManageBookmarks) {
        Notification.send({
          text: `<div style="display: flex; align-items: center;"><span style="background: #2CAF87; border-radius: 999px; width: 20px; height: 20px; display: inline-flex; align-items: center; justify-content: center; margin-right: 10px;"><i class="fa fa-check" style="color: white; padding-left: 2px; padding-top: -1px;"></i></span><span style="flex: 1">${notificationText}</span>${manageButton}</div>`,
          timeout: 3500,
        });
      }
    }
    saving = false;
    if (showManageBookmarks) {
      bookmarkCollectionStore.set(await BookmarkCollectionAjax.get());
      showMoveToBookmarkCollectionModal = true;
    }
    if (activeBookmark) {
      dispatch('bookmark-acted-upon');
    }
  };

  let displayCreateAccountModal = function () {
    showCreateAccountModal = true;
  };

  let logUserCreatedThroughBookmark = function (user) {
    try {
      let msg = '';

      if (group) {
        msg = `group: ${group && group.name} (https://benable.com${group && group.path})`;
      } else {
        msg = `rec id: ${rec.id}`;
      }

      Log.info(`New Signup - via Bookmark | ${user.name} (${user.email}) | ${msg}`);
    } catch {}
  };

  onDestroy(() => {
    unsub && unsub();
  });
</script>

<style style="text/scss" lang="scss">
  .bookmark-btn {
    cursor: pointer;
    transition: 0.2s;
    border-radius: 999px;
    user-select: none;
    display: flex;

    &.active {
      path {
        stroke: black;
        fill: black;
      }
    }

    svg {
      height: 18px;

      path {
        stroke: #000;
        stroke-width: 1.5px;
        fill: transparent;
      }
    }
  }
</style>

{#if showMoveToBookmarkCollectionModal}
  <MoveToBookmarkCollectionModal
    mobile={mobile}
    bookmarkId={activeBookmark.id}
    showModal={showMoveToBookmarkCollectionModal}
    objectText={activeBookmark.display_name}
    useSelectedCollection={true}
    currentUser={currentUser}
    on:complete={() => {
      // setTimeout(loadBookmarks, 100);
    }}
    on:close={() => {
      hideMoveToBookmarkCollectionModal();
    }} />
{/if}

<div>
  {#if showInfoStepsModal}
    <Modal
      on:close={() => {
        toggleBookmark();
        showInfoStepsModal = false;
      }}
      show={showInfoStepsModal}
      mobile={mobile}
      showCloseButton={false}
      closeOnOverlayClick={false}
      fadeInDuration={0}
      containerClass={'show-info-steps'}>
      <div slot="content" style="text-align: center;">
        <div>
          <AfterCreateInfo
            mobile={mobile}
            on:finished={(_e) => {
              toggleBookmark();
              showInfoStepsModal = false;
            }} />
        </div>
      </div>
    </Modal>
  {/if}

  {#if showCreateAccountModal}
    <CreateAccountModal
      msgStyle="font-size: 20px;"
      eventDetails={{ trigger_event: 'bookmark_button', group_base_id: group?.id, rec_object_id: rec?.id }}
      mobile={mobileForCreate || mobile}
      successCallback={(user) => {
        showCreateAccountModal = false;
        showInfoStepsModal = true;
        logUserCreatedThroughBookmark(user);
      }}
      beforeDataSend={(data) => {
        data['sign_up_source'] = {
          source: 'bookmark',
          group_base_id: group && group.id,
          rec_object_id: rec && rec.rec_object && rec.rec_object.id,
        };

        return data;
      }}
      showPassword={true}
      saveButtonFlow={true}
      buttonText="Create account"
      bind:showModal={showCreateAccountModal} />
  {/if}
</div>

<div
  class="bookmark-btn {viewStyle}"
  class:mobile={mobile}
  class:active={bookmark}
  on:click|preventDefault|stopPropagation={toggleBookmark}>
  <svg fill="none" viewBox="0 0 {viewStyle == 'feed' ? 18 : 17} 21" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1 2C1 1.44772 1.44772 1 2 1H15C15.5523 1 16 1.44772 16 2V18.6859C16 19.5622 14.9529 20.0147 14.3147 19.4142L8.5 13.9426L2.68529 19.4142C2.04709 20.0147 1 19.5622 1 18.6859V2Z"
      clip-rule="evenodd"
      fill-rule="evenodd" />
  </svg>
</div>
